var _rect, _line, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 43.2,
    height: 40,
    rx: 1,
    stroke: "#F99F5D",
    strokeWidth: 3.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 2.79687,
    x2: 11.5,
    y2: 41.1969,
    stroke: "#F99F5D",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 2.79687,
    x2: 35.5,
    y2: 41.1969,
    stroke: "#F99F5D",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.4214C28.1667 21.8063 28.1667 22.7685 27.5 23.1534L20.3 27.3104C19.6333 27.6953 18.8 27.2141 18.8 26.4443L18.8 18.1305C18.8 17.3607 19.6333 16.8796 20.3 17.2645L27.5 21.4214Z",
    stroke: "#F99F5D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.7f31061be1f7b02450d7628e51d0fcef.svg";
export { ForwardRef as ReactComponent };